
import Service from '../service.js';
export default {
  components: {
  },
  data() {
    return {
      purchaseCount: '',
      purchaseMoney: '',
      transferCount: '',
      transferMoney: ''
    };
  },
  mounted() {
    this.getHomeinfo();
  },
  methods: {
    numberFormat (value) {
      var param = {};
      var k = 10000,
        sizes = ['元', '万元', '亿', '万亿'],
        i;
      if(value < k){
        param.value =value;
        param.unit='元';
      }else{
        i = Math.floor(Math.log(value) / Math.log(k));
        param.value = ((value / Math.pow(k, i))).toFixed(2);
        param.unit = sizes[i];
      }
      return param;
    },
    getHomeinfo() {
      let key = '';
      if(Number(localStorage.level) === 2) {
        key = 'city';
      } else if(Number(localStorage.level) === 3) {
        key = 'county';
      } else if(Number(localStorage.level) === 4){
        key = 'township';
      }
      Service.showProjectInfo(key, localStorage.areaCode).then(res => {
        if (res && (res.code === '0')) {
          this.purchaseCount = res.data.dealCount; // 采购个数
          this.transferMoney = this.numberFormat(res.data.listMoney);
          this.purchaseMoney = this.numberFormat(res.data.dealMoney);
          this.transferCount = res.data.listCount; // 流转个数
        }
      });
    }
  }
};
